import { render, staticRenderFns } from "./sale-order.vue?vue&type=template&id=213e781a&scoped=true&"
import script from "./sale-order.vue?vue&type=script&lang=js&"
export * from "./sale-order.vue?vue&type=script&lang=js&"
import style0 from "./sale-order.vue?vue&type=style&index=0&id=213e781a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213e781a",
  null
  
)

export default component.exports